import React from 'react';
import { Card, CardMedia } from '@mui/material';

import Icn from './Icn';
import styles from './SelectedProductList.module.css';
import { colors } from '../maps/colors';

const SelectedProductList = ({ selectedProducts, onDelete }) => {
    return (
        <div className={styles.container}>
            {selectedProducts.map(product => (
                <Card className={styles.productContainer} key={product._id}>
                    {/* Product Image */}
                    <CardMedia
                        component="img"
                        height="48"
                        image={product.imageUrl}
                        alt="product image"
                        sx={{ objectFit: 'cover' }}
                    />
                    <Icn
                        onClick={() => onDelete(product)}
                        style={{ width: 12, height: 12, color: colors.BLACK_WITH_HALF_TRANS }}
                        className={styles.closeIcon}>
                        closeIcon
                    </Icn>
                </Card>
            ))}
        </div>
    )
}

export default SelectedProductList;